// extracted by mini-css-extract-plugin
module.exports = {"galleryGrid":"pictureGallery_galleryGrid___yq-e"};